/**
 * Module definition and dependencies
 */
angular.module("Crm.Contact.Controller", [])
/**
 * Controller
 */
.controller("contactCtrl", [function () {
  this.save = () => {
    return this.contact.createOrUpdate();
  };
}]);
/**
 * Module definition and dependencies
 */

angular.module("Crm.Contact", ["Crm.Contact.Controller", "Crm.contact.templates"])
/**
 * Config
 */
.component("contact", {
  controller: "contactCtrl",
  templateUrl: "src/contact/contact.html",
  bindings: {
    contact: "<"
  }
});
/**
 * Module definition and dependencies
 */

angular.module("contactsService.Service", ["ngResource"])
/**
 * ServicefileUpload
 */
.factory("Contacts", ["$resource", "Config", "Upload", function ($resource, Config, Upload) {
  var contactApi = $resource(Config.API_BASE_URL + "/contacts/:contactId", {
    contactId: "@id"
  }, {
    update: {
      method: "PUT"
    },
    query: {
      isArray: false,
      transformResponse: function (data) {
        let result = angular.fromJson(data);
        result.data = result.data.map(r => new contactApi(r));
        return result;
      }
    },
    queryCoacqs: {
      isArray: false,
      method: "GET",
      url: Config.API_BASE_URL + "/contacts/:contactId/coacquereurs"
    },
    queryExport: {
      isArray: false,
      method: "GET"
    }
  });

  contactApi.prototype.createOrUpdate = function () {
    if (this.id) {
      return this.$update();
    } else {
      return this.$save();
    }
  };

  contactApi.prototype.setProfilImage = function (file) {
    if (!file) {
      return;
    }

    this.file = file;
    return file.upload = Upload.base64DataUrl(file).then(urls => {
      this.image = urls;
      return this.$update();
    });
  };

  return contactApi;
}]).factory("TotalContacts", ["$resource", "Config", function ($resource, Config) {
  let totalContactsApi = $resource(Config.API_BASE_URL + "/contacts/", {}, {
    update: {
      method: "PUT"
    },
    query: {
      isArray: false
    }
  });
  return totalContactsApi;
}]).factory("ContactsCheck", ["$resource", "Config", function ($resource, Config) {
  let api = $resource(Config.API_BASE_URL + "/contacts/check", {}, {
    query: {
      isArray: false
    }
  });
  return api;
}]).factory("PromoteursContactsCheck", ["$resource", "Config", function ($resource, Config) {
  let api = $resource(Config.API_BASE_URL + "/promoteurs/:commercialisateurId/contacts/check", {
    commercialisateurId: "@commercialisateurId"
  }, {
    query: {
      isArray: false
    }
  });
  return api;
}]).factory("ContactFicheConsultees", ["$http", "Config", function ($http, Config) {
  return {
    getContactFicheConsultees: function (configParams) {
      return $http({
        method: "GET",
        url: Config.API_BASE_URL + "/contacts/?last_consultations=10",
        params: configParams
      });
    }
  };
}]).factory("ContactsAtraiter", ["$http", "Config", function ($http, Config) {
  return {
    getStatsContactsAtraiter: function (configParams) {
      return $http({
        method: "GET",
        url: Config.API_BASE_URL + "/contacts/?limit=1&groupe_avancement=1",
        params: configParams
      });
    }
  };
}]).factory("Config", ["$http", "Config", function ($http, Config) {
  return {
    getStatsContactsAtraiter: function () {
      return $http({
        method: "GET",
        url: Config.API_BASE_URL_PUBLIC + "/contacts/?limit=1&groupe_avancement=1"
      });
    }
  };
}]).factory("ContactHistorique", ["$resource", "Config", function ($resource, Config) {
  let contactHistoriqueApi = $resource(Config.API_BASE_URL + "/historiques?contact_id=:contactId", {
    contactId: "@contactId"
  }, {
    update: {
      method: "PUT"
    },
    query: {
      isArray: false
    }
  });

  contactHistoriqueApi.prototype.createOrUpdate = function () {
    if (this.id) {
      return this.$update();
    } else {
      return this.$save();
    }
  };

  return contactHistoriqueApi;
}]).factory("ContactActiverEspaceClient", ["$resource", "Config", function ($resource, Config) {
  let api = $resource(Config.API_BASE_URL_PUBLIC + "/contacts/demand-activation", {}, {
    update: {
      method: "PUT"
    },
    query: {
      isArray: false
    }
  });

  api.prototype.createOrUpdate = function () {
    if (this.id) {
      return this.$update();
    } else {
      return this.$save();
    }
  };

  return api;
}]).service("ContactGroupe", function () {
  let contactGroupeId;
  return {
    getContactGroupeId: function () {
      return contactGroupeId;
    },
    setContactGroupeId: function (value) {
      contactGroupeId = value;
    }
  };
}).service("ListeContacts", function () {
  let listeContacts;
  return {
    getListeContacts: function () {
      return listeContacts;
    },
    setListeContacts: function (value) {
      console.log("value");
      console.log(value);
      return listeContacts = value;
    }
  };
}).factory("ContactsAttribution", ["$resource", "Config", function ($resource, Config) {
  let api = $resource(Config.API_BASE_URL + "/contacts/attributions", {}, {
    update: {
      method: "PUT"
    },
    query: {
      isArray: false
    }
  });

  api.prototype.createOrUpdate = function () {
    if (this.id) {
      return this.$update();
    } else {
      return this.$save();
    }
  };

  return api;
}]).factory("ContactsAvancements", ["$resource", "Config", function ($resource, Config) {
  let api = $resource(Config.API_BASE_URL + "/contacts/avancements", {}, {
    update: {
      method: "PUT"
    },
    query: {
      isArray: false
    }
  });

  api.prototype.createOrUpdate = function () {
    if (this.id) {
      return this.$update();
    } else {
      return this.$save();
    }
  };

  return api;
}]);
angular.module('Crm.contact.templates', []).run(['$templateCache', function($templateCache) {$templateCache.put('src/contact/contact.html','<div class="panel panel-default contact"><div class="panel-heading"><h3 class="panel-title d-flex justify-content-between align-items-center">Identit\xE9 du client<ecrire-btn contacts-selectionner="[$ctrl.contact]" disabled="true" add-class="\'btn btn-tertiary btn-sm\'" ng-if="$root.commercialisateur.messagerie_desactiver === false"></ecrire-btn></h3></div><div class="panel-body"><div class="row"><div class="col-xs-12 col-md-3" ng-if="$ctrl.contact.image"><div class="thumbnail" ngf-background="$ctrl.contact.image" style="background-image:url({{ $ctrl.contact.image }});background-size:cover;background-position:center;background-repeat: no-repeat;"></div></div><div ng-class="{\'col-xs-12 col-md-9\': $ctrl.contact.image, \'col-xs-12\':!$ctrl.contact.image}"><div class="row"><div class="col-xs-12 col-sm-4"><div class="form-group"> <label>Civilit\xE9</label><div class="form-group--select"> <i class="material-icons">arrow_drop_down</i> <select class="form-control" name="civilite" ng-model="$ctrl.contact.civilite"><option value="">Civ.</option><option value="M" label="M.">M.</option><option value="F" label="Mme">Mme</option><option value="MF" label="M. et Mme">M. et Mme</option></select></div></div></div><div class="col-xs-12 col-sm-4"><div class="form-group"> <label>Nom</label><div class="form-group--select"> <input type="text" class="form-control" ng-model="$ctrl.contact.nom"/></div></div></div><div class="col-xs-12 col-sm-4"><div class="form-group"> <label>Pr\xE9nom</label><div class="form-group--select"> <input type="text" class="form-control" ng-model="$ctrl.contact.prenom"/></div></div></div><div class="col-xs-12 col-sm-4"><div class="form-group"> <label>Email</label><div class="form-group--select"> <input type="text" class="form-control" ng-model="$ctrl.contact.email"/></div></div></div><div class="col-xs-12 col-sm-4"><div class="form-group"> <label>T\xE9l\xE9phone fixe</label><div class="form-group--select"> <input type="text" class="form-control" ng-model="$ctrl.contact.tel"/></div></div></div><div class="col-xs-12 col-sm-4"><div class="form-group"> <label>T\xE9l\xE9phone mobile</label><div class="form-group--select"> <input type="text" class="form-control" ng-model="$ctrl.contact.tel_mobile"/></div></div></div><div class="col-xs-12 col-sm-6"><div class="form-group"> <label>Adresse</label><div class="form-group--select"> <input type="text" class="form-control" ng-model="$ctrl.contact.adresse1"/></div></div></div><div class="col-xs-12 col-sm-6"><div class="form-group"> <label>Adresse 2</label><div class="form-group--select"> <input type="text" class="form-control" ng-model="$ctrl.contact.adresse2"/></div></div></div><div class="col-xs-12 col-sm-4"><div class="form-group"> <label>Ville</label><div class="form-group--select"> <input type="text" class="form-control" ng-model="$ctrl.contact.ville"/></div></div></div><div class="col-xs-12 col-sm-4"><div class="form-group"> <label>Code postal</label><div class="form-group--select"> <input type="text" class="form-control" ng-model="$ctrl.contact.cp"/></div></div></div><div class="col-xs-12 col-sm-4"><div class="form-group"> <label style="visibility: hidden; height: 20px;">Enregistrer</label><div class="form-group--select text-center"> <button class="btn btn-secondary" ng-click="$ctrl.save()" ng-disabled="!$ctrl.contact.email && !$ctrl.contact.tel" promise-btn> <span class="btn-text">Enregistrer</span></button></div></div></div></div></div></div></div></div>');}]);